// 公司更名后的默认资料。公开页面优先使用后台保存的联系资料。
export const companyIdentity = {
    zh: {
        name: '杭州技卫士智能技术有限公司',
        shortName: '杭州技卫士',
        address: '杭州市临平区金成国际科技城4号楼'
    },
    en: {
        name: 'Hangzhou Jiweishi Intelligent Technology Co., Ltd.',
        shortName: 'JWS',
        address: 'Block No. 4, Jincheng International Scientific City, Linping Zone, Hangzhou City, Zhejiang Province, China'
    }
};
//# sourceMappingURL=company-identity.js.map